import baseFetch, { createParamString } from 'common/baseFetch';
import type { Units } from 'types/units';
import type { WindResponse } from 'types/wind';

interface Options {
  noCache?: boolean;
}

const fetchForecastedWind = (
  spotId: string,
  days: number,
  intervalHours: number,
  corrected: boolean,
  units: Units,
  { noCache }: Options = { noCache: false },
) => {
  const headers = new Headers();
  let cacheEnabled = !!units?.windSpeed;
  if (noCache) {
    headers.set('Cache-Control', 'no-cache');
    cacheEnabled = false;
  }
  return baseFetch<WindResponse>(
    `/kbyg/spots/forecasts/wind?${createParamString({
      spotId,
      days,
      intervalHours,
      corrected,
      cacheEnabled,
      'units[windSpeed]': units?.windSpeed ?? null,
    })}`,
    {
      headers,
    },
  );
};

export default fetchForecastedWind;
